module.exports = __webpack_public_path__ + "static/media/namecard-with-name.8dd3e387.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/namecard-with-name.png
 ** module id = 2050
 ** module chunks = 44
 **/